var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticClass:"video-js vjs-fluid vjs-big-play-centered",attrs:{"id":"videoPlayer"}})}
var staticRenderFns = []

export { render, staticRenderFns }